<template>
  <div class="com-box">
    <img class="head-img" src="https://img3.quanyou.com.cn/joyNew/group1/M00/1D/DF/rB8LrmU6FeqALn6zAABM6xqiMoE503.png" alt="" />
    <div class="card">
      <div class="centent" >
        <div class="title" v-if="attentionTitle">
          <img src="https://img3.quanyou.com.cn/joyNew/group1/M00/1D/06/rB8LrWUwweGAC4fYAAAC1BJnx40509.png" alt="" />
          <span class="title-title">{{attentionTitle}}</span>
          <img src="https://img3.quanyou.com.cn/joyNew/group1/M00/1D/06/rB8LrWUwweGAC4fYAAAC1BJnx40509.png" alt="" />
        </div>
        <div v-html="attentionMsg"></div>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from './mixins'
export default {
  mixins: [mixins]
}
</script>

<style lang="stylus" scoped>
  .com-box {
    .head-img {
      width: 100%;
      height: 50px;
    }
    .card {
      width: 100%;
      min-height: 137px;
      margin-top: -34px;
      background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1D/DF/rB8LrmU6FhqATJNjAABKmkkYdwQ777.png');
      background-size: 100% 100%;
      padding-bottom: 30px;
      overflow hidden
      box-sizing: border-box;
      .centent {
        width: 330px;
        min-height: 100px;
        color: #EE591D;
        font-size: 14px;
        border-radius: 5px;
        margin: auto;
        margin-top: 24px;
        padding: 15px 12px;
        box-sizing: border-box;
        .title {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 10px;
          .title-title {
            color: #E24409;
            margin: 0 6px;
            font-weight: bold;
          }
          img {
            width: 14px;
            height: 14px;
          }
        }
      }
    }
  }
</style>